function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useFormContext } from 'components/Form/FormContext';
import { CheckIcon } from 'components/Icon/Check';
import { IndeterminateIcon } from 'components/Icon/Indeterminate';
import * as S from './Checkbox.styles';

/**
 * @deprecated Use string literals instead: 'large' or 'small'.
 */
export let CheckboxSize = /*#__PURE__*/function (CheckboxSize) {
  CheckboxSize["SMALL"] = "small";
  CheckboxSize["LARGE"] = "large";
  return CheckboxSize;
}({});
const Checkbox = /*#__PURE__*/React.forwardRef(({
  id,
  ariaLabel,
  defaultChecked,
  checked,
  onCheckedChange,
  disabled,
  required,
  name,
  value,
  label,
  hasError,
  tabIndex,
  size,
  marginLeft
}, ref) => {
  const context = useFormContext();
  const rootProps = {
    id,
    defaultChecked,
    checked,
    onCheckedChange,
    disabled,
    required,
    name,
    value,
    label
  };
  const IndicatorIcon = checked === 'indeterminate' ? IndeterminateIcon : CheckIcon;
  const dataDisabled = disabled || undefined;
  const iconSize = size === 'large' ? 'large' : 'medium';
  const getSizeVariant = () => {
    if (size) {
      return size;
    }

    // Since Checkboxes don't have a `medium` size variant we use the small version for medium sized forms
    if (context?.inputSize === 'large') {
      return 'large';
    }
    return 'small';
  };
  const sizeVariant = getSizeVariant();
  return /*#__PURE__*/React.createElement(S.CheckboxContainer, {
    "data-disabled": dataDisabled,
    $size: sizeVariant
  }, /*#__PURE__*/React.createElement(S.CheckboxRoot, _extends({
    $error: hasError,
    $size: sizeVariant,
    $marginLeft: marginLeft,
    "aria-label": ariaLabel,
    tabIndex: tabIndex,
    ref: ref
  }, rootProps), /*#__PURE__*/React.createElement(S.CheckboxIndicator, {
    $error: hasError
  }, /*#__PURE__*/React.createElement(IndicatorIcon, {
    fill: "white",
    size: iconSize,
    variant: "bold"
  }))), label ? /*#__PURE__*/React.createElement(S.CheckboxLabel, {
    htmlFor: id,
    "data-disabled": dataDisabled,
    $size: sizeVariant
  }, label, " ", required && /*#__PURE__*/React.createElement(S.CheckboxRequiredIcon, null)) : null);
});
export { Checkbox };